var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cake-layout"},[_c('router-view')],1),_c('layoutTabbar',{attrs:{"tab-list":_vm.tabList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }